// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"0c5eb1c0","218":"e78bbda1","578":"637d0dd2","824":"7f1e323f"}[chunkId] + ".chunk.js";
};